import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import ChangeNumber from 'src/components/settings/ChangeNumber';
const ChangeNumberModal = observer(props => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const phoneNumber = props.phoneNumber,
    setPhoneConfirmed = props.setPhoneConfirmed;
  const authIsConfirmed = store.account.userProfile.authIsConfirmed;
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    'custom-attribute': '282-change-number'
  }, t('profile_settings.change_number'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, !authIsConfirmed ? /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t('profile_settings.change_number'),
    trigger: trigger
  }, /*#__PURE__*/React.createElement(ChangeNumber, {
    insideModal: true,
    phoneNumber: phoneNumber,
    setPhoneConfirmed: setPhoneConfirmed
  })) : null);
});
export default ChangeNumberModal;